import axios from "axios";
import React, { useContext } from "react";
import { useState, useEffect } from "react";
import authenticate from "../../utils/Authenticate";
import UserContext from "../../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import displayError from "../../utils/ErrorHandler";
const XLSX = require("xlsx");

const UploadItem = () => {
  const [file, setFile] = useState({});
  const [isLoading, setIsLoading] = useState(false);
const [uploadSummary, setUploadSummary] = useState(null); 
  const [itemInventoryData, setItemInventoryData] = useState([]);
  const [message, setMessage] = useState("");
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    units: "",
    price: "",
  });
  const [notification, setNotification] = useState({ message: '', type: '' });

  const handleChange = (event) => {
    setFile(event.target.files[0]);
    setMessage("");
    const columns = ["sno", "category", "name", "unit", "purchaseType","basePrice"];
    const startRow = 2;
    const columnsToInclude = columns.slice(1);
    console.log("file details", file);

    const reader = new FileReader();
    if (event?.target?.files[0]) {
      reader.readAsArrayBuffer(event.target.files[0]);
      reader.onload = (event) => {
        const arrayBuffer = event?.target?.result;
        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const sheetName = workbook.SheetNames[0]; // Get the first sheet by default
        const worksheet = workbook.Sheets[sheetName];
        const headers = XLSX.utils.sheet_to_json(worksheet, { header: 2 })[0];

        const data = XLSX.utils.sheet_to_json(worksheet, {
          header: headers,
          range: startRow - 1, // XLSX uses 0-based indexing for rows
          defval: "", // Default value for empty cells
        });
        console.log("excel file ", data);
        const filteredData = data
          .map((row) => {
            const filteredRow = {};
            columnsToInclude.forEach((col, index) => {
              if (
                row[col] !== null &&
                row[col] !== undefined &&
                row[col] !== ""
              ) {
                filteredRow[col] = row[col];
              }
            });
            return filteredRow;
          })
          .filter((row) => Object.keys(row).length > 0); // Filter out empty rows
        console.log("excel file ", filteredData);
        setItemInventoryData(filteredData);
      };
    }
    // submitData(event);
  };

  const submitData = (e) => {
    e.preventDefault();
setIsLoading(true); // Start loader
setNotification({ message: '', type: '' }); // Reset notification
setMessage(""); // Reset message
setUploadSummary(null); // Reset upload summary

    console.log("Submitting it file ", file);

    console.log(itemInventoryData);
    axios
      .post(
        `${process.env.REACT_APP_API_URI}/api/items/create/bulkItemDetails`,
        itemInventoryData,
        { withCredentials: true }
      )
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          setNotification({ message: response.data.message, type: 'success' });
          //navigate("central/items");
          setUploadSummary(response.data.summary);
        }
      })
      .catch((err) => {
        const errorMessage = displayError(err,navigate,setUser);
        console.log(errorMessage);
          if(errorMessage){
            setNotification({ message: errorMessage, type: 'error' });
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
          }
      })
      .finally(() => {
      setIsLoading(false); // End loader
    });
  };

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
    }
    startup();
  }, [user,file]);

  const design = (
    <>
    {notification.message && (
          <div
            className={`m-2 mb-4 p-4 ${notification.type === 'success' ? 'bg-green-200 border-green-600 text-green-600' : 'bg-red-200 border-red-600 text-red-600'}`}
          >
            {notification.message}
          </div>
        )}
        {uploadSummary && (
  <div className="bg-gray-100 p-4 rounded-md mt-4 border border-gray-300">
    <h2 className="text-lg font-semibold text-gray-700 mb-2">Upload Summary</h2>
    <ul className="text-sm text-gray-800 space-y-1">
      <li>✅ <strong>{uploadSummary.insertedCount}</strong> items inserted</li>
      <li>⚠️ <strong>{uploadSummary.duplicateCount}</strong> duplicates skipped</li>
      <li>❌ <strong>{uploadSummary.failedCount}</strong> failed to insert</li>
    </ul>
  </div>
)}
      <div className="mt-10 mx-5 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" onSubmit={submitData}>
          <div>
            {/* onClick={()=>uploadExcel('C:/Users/YusufHK/Downloads/Copy of Muwaid_Store_Inventory(1).xlsx',2,['sno','category', 'name', 'unit'])} */}
            <input
              type="file"
              className="flex w-full justify-center rounded-full text-white bg-fmb px-3 py-3 text-sm font-semibold leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onChange={handleChange}
              accept=".xlsx, .xls .csv"
            />
            {console.log(file)}
          </div>
          {/* {file && file.length > 0 ? ( */}
          {isLoading && (
  <div className="flex justify-center mt-4">
    <svg
      className="animate-spin h-8 w-8 text-blue-600"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4l3.5-3.5L12 0v4a8 8 0 018 8z"
      ></path>
    </svg>
  </div>
)}
            <>
              <div>
                <button
                  type="submit"
                  onClick={submitData}
                  className={`flex w-full  justify-center rounded-full
                   text-white bg-fmb px-3 py-3 text-sm font-semibold 
                   leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline 
                   focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                >
                  UPLOAD ITEM
                </button>
              </div>
              <div
                className={`flex w-full justify-center ${
                  !message ? "hidden" : "block"
                }  text-white bg-orange-400 px-3 py-3 text-sm font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
              >
                <span>{message}</span>
              </div>
            </>
          {/* ) : (
            <div></div>
          )} */}
        </form>

        <div className="flex justify-center mt-4">
          <a
            href="/ItemsInventoryUpload.xlsx"
            download="ItemsInventoryUpload.xlsx"
            className="flex w-full justify-center
             rounded-full text-white  bg-fmb px-3 py-3 text-sm font-semibold 
                   leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline 
                   focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`"
          >
            DOWNLOAD TEMPLATE FILE
          </a>
          </div>
      </div>
    </>
  );

  return design;
};

export default UploadItem;
